module.exports = __webpack_public_path__ + "img/events.bd80165d.png";